interface HeapSetIdentity {
  contractorId: string | number;
  contractorName: string | number;
}

export const heapSetIdentity = ({ contractorId, contractorName }: HeapSetIdentity) => {
  if (window.heap) {
    window.heap.identify(`${contractorId}`);
    window.heap.addUserProperties({ contractor_name: `${contractorName}`, contractor_id: `${contractorId}` });
  }
};

export const heapResetIdentity = () => {
  if (window.heap) {
    window.heap.resetIdentity();
  }
};

export const heapAddEventProperties = (key: string, value: string | number | boolean) => {
  window.heap?.addEventProperties({
    [key]: value,
  });
};

export const heapRemoveEventProperty = (key: string) => {
  window.heap?.removeEventProperty(key);
};
